import classNames from 'classnames';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';

import css from './BooksDateCalendarMonth.module.scss';

interface DayProps extends React.ComponentProps<'button'> {
  className?: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  date: number;
  disabled: boolean;
  current: boolean;
  selected?: boolean;
}

interface MonthProps extends React.HTMLProps<{}> {
  className?: string;
}

export const BooksDateCalendarDay = ({
  onClick,
  date,
  disabled,
  selected,
  current,
  ...attr
}: DayProps) => {
  return (
    <li className={css.BooksDateCalendarDay}>
      {current && (
        <button
          {...attr}
          type="button"
          onClick={onClick}
          disabled={disabled}
          className={css.BooksDateCalendarDay__Button}
          data-style={selected ? 'selected' : ''}
          data-qa={`${disabled ? 'disabled' : 'active'}CalendarButton`}
        >
          {date}
        </button>
      )}
    </li>
  );
};

const BooksDateCalendarMonth = ({
  className,
  children,
  intl,
}: MonthProps & InjectedIntlProps) => {
  const classes = classNames(css.BooksDateCalendarMonth, className);
  const dateCalendarWeek = ['sun', 'man', 'tue', 'wed', 'thu', 'fri', 'sat'];

  return (
    <div className={classes}>
      <ol className={css.BooksDateCalendarMonth__Dotw}>
        {dateCalendarWeek.map((weekday, i) => (
          <li key={i} className={css.BooksDateCalendarMonth__DotwItem}>
            {intl.formatMessage({ id: `books.calendar.${weekday}` })}
          </li>
        ))}
      </ol>
      <div className={css.BooksDateCalendarMonth__Body}>
        <ol className={css.BooksDateCalendarMonth__Day}>{children}</ol>
      </div>
    </div>
  );
};

export default injectIntl(BooksDateCalendarMonth);
